import { useContext } from 'react'

import { RouterContext } from './RouterContext'

export const useRouterContext = () => {
    const context = useContext(RouterContext);

    if(!context) throw new Error('useRouterContext needs to be used within RouterContext.Provider!');

    return context;
}